import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './styles';

const HelloWorld = ({ title }) => (
  <Container primary>
    <h1>
      Hello World:&nbsp;
      {title}
    </h1>
  </Container>
);

HelloWorld.defaultProps = {
  title: 'ReactJS',
};

HelloWorld.propTypes = {
  title: PropTypes.string,
};

export default HelloWorld;
